import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'
import { NetworkConnectionStatusEnum } from '../enums/NetworkConnectionStatus.enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectionStatusIcon',
  props: {
    status: null
  },
  setup(__props: any) {



return { __sfc: true,Icon, NetworkConnectionStatusEnum }
}

})